import { render, staticRenderFns } from "./UpgradeAccount.vue?vue&type=template&id=701bc2a1&scoped=true&"
import script from "./UpgradeAccount.vue?vue&type=script&lang=js&"
export * from "./UpgradeAccount.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeAccount.vue?vue&type=style&index=0&id=701bc2a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701bc2a1",
  null
  
)

export default component.exports